import { MfaBackupCodeAcknowledgement } from '@dynamic-labs/sdk-api-core';

import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';

/**
 * Checks if the user is still pending acknowledgment of their MFA recovery codes.
 *
 * This function determines whether the user has been presented with recovery
 * codes that they have not yet acknowledged as saved or backed up.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if recovery codes are pending acknowledgment, false otherwise.
 */
export const isPendingRecoveryCodesAcknowledgment = (
  client = getDefaultClient()
) => {
  const user = client.user;

  assertDefined(user, 'User not logged in');

  return (
    user.mfaBackupCodeAcknowledgement === MfaBackupCodeAcknowledgement.Pending
  );
};
